import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GeometryTab } from "@/components/GeometryTab";
import { PanelsTab } from "@/components/PanelsTab";
import { SpecsTab, TitleTab } from "@/components/SpecsTab";

const TABS = [["geometry", "Geometry"], ["panels", "Panels"], ["specs", "Sys+Glass"], ["title", "Title"]];

export const PropertiesPanel = ({ item, update, selected, setSelected, tb, setTb, applyFaceToAll, projectId, hasPdf, items }) => (
  <aside className="w-full lg:w-[340px] shrink-0 border-l border-slate-800 bg-[#111827] flex flex-col min-h-0" data-testid="properties-panel">
    <Tabs defaultValue="geometry" className="flex flex-col min-h-0 flex-1">
      <TabsList className="h-12 rounded-none w-full grid grid-cols-4 bg-[#0d1220] border-b border-slate-800 p-1">
        {TABS.map(([v, l]) => (
          <TabsTrigger key={v} value={v} data-testid={`tab-${v}`}
            className="text-xs font-mono uppercase tracking-wider data-[state=active]:bg-slate-800 data-[state=active]:text-cyan-300">{l}</TabsTrigger>
        ))}
      </TabsList>
      <div className="flex-1 overflow-y-auto p-4">
        <TabsContent value="geometry" className="mt-0"><GeometryTab item={item} update={update} applyFaceToAll={applyFaceToAll} projectId={projectId} hasPdf={hasPdf} items={items} /></TabsContent>
        <TabsContent value="panels" className="mt-0"><PanelsTab item={item} update={update} selected={selected} setSelected={setSelected} /></TabsContent>
        <TabsContent value="specs" className="mt-0"><SpecsTab item={item} update={update} /></TabsContent>
        <TabsContent value="title" className="mt-0"><TitleTab tb={tb} setTb={setTb} /></TabsContent>
      </div>
    </Tabs>
  </aside>
);
